module.exports = __webpack_public_path__ + "static/media/about-img.e665cb1f.jpg";